import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import styles from './auth.module.css';

type Props = {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
  /** Kept for the sign-in screen's call site; every auth screen now shares the split layout. */
  hero?: boolean;
};

const TRUST = [
  { image: '/assets/illustrations/verified.png', text: 'Prestataires vérifiés par notre équipe' },
  { image: '/assets/illustrations/money.png', text: 'Plusieurs propositions, vous choisissez' },
  { image: '/assets/illustrations/support.png', text: 'Suivi de mission et support humain' },
];

export default function AuthLayout({ title, subtitle, children, footer }: Props) {
  return (
    <div className={styles.page}>
      <aside className={styles.brandPanel}>
        <p className={styles.brandLine}>Des services à domicile en toute confiance.</p>
        <ul className={styles.brandList}>
          {TRUST.map((item) => (
            <li key={item.text}>
              <img src={item.image} alt="" />
              <span>{item.text}</span>
            </li>
          ))}
        </ul>
      </aside>

      <main className={styles.formPane}>
        <div className={styles.card}>
          <Link to="/" className={styles.logoLink} aria-label="DABA, accueil">
            <img className={styles.logo} src="/assets/brand/logo.png" alt="DABA" />
          </Link>

          <div className={styles.heading}>
            <h1 className={styles.title}>{title}</h1>
            {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
          </div>

          {children}

          {footer ? <div className={styles.footer}>{footer}</div> : null}
        </div>
      </main>
    </div>
  );
}
